import Vue from 'vue'
import App from './App.vue'
import router from './router'

import '@vant/touch-emulator';
import Vant from 'vant';
// import 'vant/lib/index.css';
import '@/assets/wcc.css'


Vue.use(Vant);


import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios);

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

var moment = require('moment');
moment.locale('zh-cn');
Vue.prototype.moment = moment;

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
